/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
    "use strict";

    interface IDaysPriorScope extends ng.IScope {
        name: string;
        currentValue: ng.INgModelController;
        labelRight?: string;
    }

    export class MeevoDaysPrior {
        restrict = "E";
        scope = {
            name: "@",
            currentValue: "=ngModel",
            labelRight: '@?'
        };

        require = "ngModel";

        templateUrl = "app/components/controls/daysPriorTemplate.html";

        link = (scope: IDaysPriorScope, element: angular.IAugmentedJQuery, attrs: angular.IAttributes, ngModel: angular.INgModelController) => {
            scope.labelRight || (scope.labelRight = 'LABEL_DAYS_BEFORE');
        };

        constructor(private $translate: angular.translate.ITranslateService) {

        }

        static factory(): angular.IDirectiveFactory {
            let directive = ($translate) => {
                return new MeevoDaysPrior($translate);
            };

            directive.$inject = ["$translate"];
            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoDaysPrior", MeevoDaysPrior.factory());

}
